import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { assert } from '../../assert';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaRequiredSDK } from './types';

const ariaRequiredSDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaRequiredSDK
> = ({ setProps, props }) => ({
  get required() {
    return props.ariaAttributes?.required;
  },
  set required(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        required: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createAriaRequiredSDK = withValidation(ariaRequiredSDKFactory, {
  type: ['object'],
  properties: {
    required: {
      type: ['string', 'boolean'],
      enum: ['false', 'true'],
    },
  },
});
